define('controllers/signup',['require','ractivejs','utils','layout','rv!templates/about/partials/signup'],function(require) {
    var Ractive = require('ractivejs');
    var utils = require('utils');
    var layout = require('layout');
    var signUpController = {
        /**
         * set up so it can be called multiple times. 
         * Always send a request to refresh state data (unless one is already in progress)
         * If we have the data in state return that.
         * the 
         * @param {string} customerShortId 
         * @returns {Promise} 
         */
        _getData: function(customerShortId, qs) {
            var state = window.app.controllerManager.state;

            //set employer from qs if any
            if (!utils.isNullOrWhiteSpace(qs.c)) {
                signUpController.setCompanyCookie(qs.c);
            }

            //use customerShortId to get Provider information
            this.data = this.data || $.when(
                $.get('/api/customers/GetCustomerBranding/?shortid={0}'.format(customerShortId || '')),
                $.get('/api/customers/GetSignUpCustomers')
            ).then(function(customerBranding, signUpCustomers) {
                this.data = null;
                var customer = customerBranding[0];
                state.signup = {
                    customer: customer,
                    customers: signUpCustomers[0]
                };

                if (this.ractive != null) {
                    this.ractive.set('customer', state.signup.customer);
                }
                signUpController.setCompanyCookie(customer == null ? 0 : customer.CustomerId);
                return state.signup;
            }.bind(this));
            return state.signup != null ?
                $.Deferred().resolve(state.signup).promise() :
                this.data;
        },

        load: function (customerShortId, querystring) {
            var qs = utils.deserializeQs(querystring);
            return this._getData(customerShortId, qs).then(init);

            function init(result) {
                var customer = result.customer;
                var customers = result.customers;
                var cookieMember = utils.tryGetValue(window, 'ServerData.cookieUser.member');
                
                if (!utils.isNullOrWhiteSpace(customerShortId) && customer != null && customer.CustomerId != null) {
                    //only reset the company cookie if there is a customer short url present.
                    signUpController.setCompanyCookie(customer.CustomerId);
                }

                signUpController.ractive = new Ractive({
                    el: 'layout-enroll',
                    template: require('rv!templates/about/partials/signup'),
                    data: {
            customer: customer,
            Settings: window.ServerData.Settings,
          },
                });

                signUpController.ractive.on({
                    clearEmployer: function(e) {
                        e.original.preventDefault();
                        gaTrack('SignUp', 'ClearProvider', employer.val(), 1);
                        signUpController.setCompanyCookie(0);
                        resetMatchPercentageCookie();
                        this.set('customer', null);
                        window.app.controllerManager.state.signup.customer = null;
                        $('#employer').focus();
                    }
                });

                //memberForm
                var formContext = $("#enrollmentForm #form"),
                    fname = $("#firstName", formContext),
                    lname = $("#lastName", formContext),
                    email = $("#email", formContext),
                    employer = $("#employer", formContext),
                    COOKIE_enrolledSuccessfully = "enrolledSuccessfully",
                    btnGetStarted = $("#btnGetStarted");

                //var signUpData = window.ServerData.feData.signUpData || {}; //todo:probs pass in to load. Go through code-behind to get a feel for what needs to happen. 
                var employerName = customer == null ? '' : customer.Name_Full;
                var memberCompletedSteps = utils.tryGetValue(window, 'ServerData.cookieUser.status.completedSteps'); //signUpData.CompletedStepsArray;

                var enrolledMember = {
                    init: function() {
                        var member = this.get();
                        if (member) {
                            this.set(member);
                        } else {
                            this.form().show();
                            this.afterSuccess().hide();
                        }

                        $("a.clearSetMember, #enrollAgain", this.afterSuccess()).on("click", this.clear);
                    },
                    setCookie: function(member) {
                        var eDate = CookieUtil.expireDate(50000), //expiration date waaaay out
                            domain = ServerData.isProd ? "adestinn.com" : undefined;
                        CookieUtil.set(COOKIE_enrolledSuccessfully, member.id, eDate, "/", domain);
                    },
                    set: function(member) {
                        this.setCookie(member);

                        member.FirstName = member.FirstName.toTitleCase();
                        member.LastName = member.LastName.toTitleCase();
                        member.Email = member.Email.toLowerCase();
                        cookieMember = member;

                        //set up form
                        $(".memberFN", this.afterSuccess()).text(member.FirstName);
                        $(".memberEmail", this.afterSuccess()).text(member.Email);
                        $("a.activationLink", this.afterSuccess()).attr("href", "/registration/?p=" + member.id);
                        if (member.Approved) {
                            $("#memberWasApproved", this.afterSuccess()).show();
                            $("#memberBeingReviewed", this.afterSuccess()).hide();
                        } else {
                            $("#memberWasApproved", this.afterSuccess()).hide();
                            $("#memberBeingReviewed", this.afterSuccess()).show();
                        }

                        fname.val(member.FirstName);
                        lname.val(member.LastName);
                        email.val(member.Email);
                        employer.val(member.Employer);

                        //show them where to go next...
                        if (member.UserId != null) {
                            $("#Activated", this.afterSuccess()).show();

                            var NotLinked = $.inArray(3, memberCompletedSteps) == -1;
                            if (NotLinked) {
                                $("#NotLinked", this.afterSuccess()).show();
                            }
                        } else {
                            $("#NotActivated", this.afterSuccess()).show();
                        }

                        //finally swap form with newly set up after success div
                        this.form().hide();
                        this.afterSuccess().show();
                    },
                    get: function() {
                        return cookieMember;
                    },
                    clear: function(e) {
                        if (e != undefined) e.preventDefault();

                        if ($(this).attr("data-clear") == "true") {
                            CookieUtil.unset(COOKIE_enrolledSuccessfully, "/");
                            CookieUtil.unset(COOKIE_enrolledSuccessfully, "/", "adestinn.com");
                            resetMatchPercentageCookie();
                            clearBoxes();

                            // force page refresh to reload cookie dependent values
                            window.location.reload();
                        }

                        enrolledMember.form().show();
                        enrolledMember.afterSuccess().hide();
                    },
                    //lazy-loaded properties
                    _form: null,
                    form: function() {
                        if (this._form == null) this._form = $("#formAndBranding");
                        return this._form;
                    },
                    _afterSuccess: null,
                    afterSuccess: function() {
                        if (this._afterSuccess == null) this._afterSuccess = $("#afterSuccess");
                        return this._afterSuccess;
                    }
                };
                enrolledMember.init();

                $("input[type='text']", formContext).on("change", function() {
                    validateBox($(this));
                });
                email.on("change", validateEmail);

                if (employerName != null && employerName !== "") {
                    employer.val(Utilities.htmlDecode(employerName)).prop('disabled', true);
                }

                var customerNames = customers; // window.ServerData.feData.customerNames; 
                if (customerNames != undefined) {
                    employer.autocomplete({
                        source: customerNames,
                        delay: 100,
                        select: updateProvider
                    }); //"/public/CustomerSearchAJAX.aspx", delay: 0 }); //ajax was really slow for some reason 2-7 full seconds of waiting per search...

                    $.ui.autocomplete.prototype._renderMenu = function(ul, items) {
                        var self = this;
                        $.each(items, function(index, item) {
                            if (index < 5) // here we define how many results to show
                            {
                                self._renderItemData(ul, item);
                            }
                        });
                    }
                }

                $(".resendEmail").on('click', function(e) {
                    e.preventDefault();
                    var $this = $(this);

                    $this.hide().next().show();
                    var member = enrolledMember.get();

                    if (member != null) {
                        member.resendEmail = true;
                        saveMember($this, member, function() { $this.show().next().hide(); });
                    }
                });
                btnGetStarted.on('click', function(e) {
                    if (validate()) {
                        var $this = $(this),
                            FirstHit = CookieUtil.get("FirstHit"),
                            member = {
                                Email: email.val(),
                                FirstName: fname.val(),
                                LastName: lname.val(),
                                Employer: employer.val(),
                                fromFaceBook: requestQueryString("f") != "",
                                FirstHit: FirstHit == null ? "" : FirstHit,
                                SignUpLocation: window.location.toString().replace(/^(?:\/\/|[^\/]+)*\//, ""),
                                ReferralId: qs.r
                            };

                        window.gaTrack('conversions', 'Get Started', member.Email, 0);
                        //clear anoncookie, so new one gets generated
                        CookieUtil.unset('AnonymousId');
                        saveMember($this, member);
                    }
                });

                function updateProvider(event, ui) {
                    //When manually updating the provider, use the whole customer name to get branding
                    var selectedCustomerName = ui && ui.item ? ui.item.value : employer.val();

                    //go grab customer image and top text
                    $.get('/api/customers/GetCustomerBranding/?shortid=' + selectedCustomerName).then(function(custBranding) {
                        signUpController.ractive.set('customer', custBranding);
                        window.app.controllerManager.state.signup.customer = custBranding;
                        signUpController.setCompanyCookie(custBranding == null ? null : custBranding.CustomerId);

                    });
                    gaTrack('SignUp', 'ManualCustomerPick', employer.val(), 1); //might be handy to know if a lot of people aren't using the short urls...
                    btnGetStarted.focus();
                }

                function saveMember($this, member, callback) {
                    $this.prop('disabled', true)
                         .val('Verifying...');
                    $.ajax({
                        type: 'POST',
                        url: "/DestinationSearch/previewClick.aspx",
                        data: member,
                        success: function(info) {
                            Utilities.handleAJAXResponse(info, function(obj) {
                                    member.Approved = obj.Approved;

                                    //if we have a message show it. Otherwise continue the user to their registration
                                    if (obj.message !== '') {
                                        showMessage(obj.message);
                                        clearBoxes();
                                        $this.prop('disabled', false);
                                    } else if (member.Approved && obj.member != null) {
                                        enrolledMember.setCookie(obj.member);
                                        $this.val('Redirecting...');
                                        window.location = "/registration/?p={0}{1}".format(obj.member.id, qs.r == null ? '' : '&r={0}'.format(qs.r));
                                        return;
                                    }
                                    $("#resendEmailbtn").off("click").on("click", function() {
                                        var $resendBtn = $(this);
                                        member.resendEmail = true;
                                        saveMember($resendBtn, member);
                                    });

                                    if (obj.fbConversionScript != "") {
                                        $(obj.fbConversionScript).insertAfter('body');
                                    }
                                    $this.prop('disabled', false);
                                },
                                function(error) {
                                    showMessage(error);
                                    $this.prop('disabled', false);
                                });

                            if (callback != undefined) callback();
                        },
                        error: function() {
                            showMessage("Something went wrong. Please re-load the page and try again or contact Adestinn Support.");
                            $this.val('Get Started').prop('disabled', false);
                        },
                        complete: function() {

                        }
                    });
                }

                function clearBoxes() {
                    fname.val("");
                    lname.val("");
                    email.val("");
                    //employer.val("");
                    //employer.prop('disabled', false);
                }

                var valid;

                function validate() {
                    valid = true;
                    validateBox2(fname);
                    validateBox2(lname);
                    validateBox(email);
                    validateBox2(employer);
                    validateEmail();

                    return valid;
                }

                function validateBox(box) {
                    var value = box.val().trim();
                    if (value == "" || value == box.attr("placeholder")) {
                        invalidBox(box);
                    } else {
                        box.css("border", "");
                    }
                }

                function validateBox2(box) {
                    var value = box.val().trim();
                    //-- Only allow Alpha, numberic and a couple special characters --
                    var match = /([^A-Z0-9_\-'.,\(\)\&\s])/gi.test(box.val());
                    if (value == "" || value == box.attr("placeholder")) {
                        invalidBox(box);
                    } else if (match) {
                        invalidBox(box);
                    } else {
                        box.css("border", "");
                    }
                }

                function invalidBox(box) {
                    valid = false;
                    box.css("border", "2px solid #6E0A03");
                }

                function validateEmail() {
                    var match = new RegExp(ServerData.Regex.Email).test(email.val());
                    if (!match) {
                        invalidBox(email);
                    }
                }

                function showMessage(message) {
                    $("#MemberShipRequestResults").html(message);
                    $("#hiddenAnchor").fancybox({
                        autoSize: true
                    }).trigger("click");
                }

                function setQsValues() {
                    email.val(qs.e);
                    fname.val(qs.fn);
                    lname.val(qs.ln);
                }

                function resetMatchPercentageCookie() {
                    //Reset the match percentage cookie when the company cookie is reset
                    //Match Percentage cookie will get repopulated by userId or the new companyId in layout.cs
                    CookieUtil.unset("MemberMatchPlan", "/");
                }

                Utilities.setDefaultButton(formContext, btnGetStarted);
                layout.initGlobalHandlers(); //placeholder
                setQsValues();
                return result;
            }
        },

        setCompanyCookie: function(customerId) {
            customerId = customerId == null ? 0 : customerId;
            if (!isNaN(customerId)) {
                CookieUtil.set("company", customerId.toString(), undefined, "/");

                //Use CustomerId to get membermatchplan and reload the page to show the match percentage
                //This allows for customer specific signup links to display their match percentage
                if (!CookieUtil.get("MemberMatchPlan") && customerId !== 0) {
                    $.get(`/api/customers/GetCustomerMatchPlanPercentage/?customerId=${customerId}`)
                    .then(function(matchPlanPercentage) {
                    //returns a string or null value
                        if (matchPlanPercentage !== null) {
                            CookieUtil.set("MemberMatchPlan", matchPlanPercentage, undefined, "/");
                            window.location.reload();
                        }                   
                    });
                }
            }
        },

        unload: function() {
            var formContext = $("#enrollmentForm #form");
            $('a.clearSetMember, #enrollAgain', $("#afterSuccess")).off('click');
            $("#btnGetStarted").off('click');
            $('#resendEmailbtn').off('click');
            $("#email", formContext).off('change');
            $('input[type="text"]', formContext).off('change');
            if (signUpController.ractive != null) {
                signUpController.ractive.teardown();
            }
        }
    };
    return signUpController;
});

